import type { ReactElement } from "react";
import { VatDeclarationApprovalRequest } from "../models.ts";
import { formatDateTime } from "../../../../../../lib/utils.ts";

function byName(name: string | null): string {
    return name ? ` door ${name}` : '';
}

export function VatDeclarationApprovalOutcome({ approvalRequest }: { approvalRequest: VatDeclarationApprovalRequest }): ReactElement | null {
    switch (approvalRequest.status) {
        case 'pending':
            if (approvalRequest.is_latest_version) {
                return null;
            }
            return (
                <div role="status" className="space-y-1 rounded-md border border-gray-200 bg-gray-50 px-4 py-3 text-sm text-gray-700">
                    <p className="font-medium text-gray-900">Deze versie is vervangen</p>
                    <p>
                        Je boekhouder heeft een nieuwere versie van deze aangifte gemaakt. Je ontvangt een nieuw verzoek zodra die klaarstaat.
                    </p>
                </div>
            );
        case 'approved':
            return (
                <div role="status" className="space-y-1 rounded-md border border-green-200 bg-green-50 px-4 py-3 text-sm text-green-800">
                    <p className="font-semibold text-green-900">BTW-aangifte goedgekeurd</p>
                    <p>
                        Goedgekeurd{approvalRequest.answered_at ? ` op ${formatDateTime(approvalRequest.answered_at)}` : ''}
                        {byName(approvalRequest.answered_by_name)}.
                    </p>
                    <p>Je boekhouder kan de aangifte nu indienen.</p>
                </div>
            );
        case 'rejected':
            return (
                <div role="status" className="space-y-1 rounded-md border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-800">
                    <p>
                        Afgewezen{approvalRequest.answered_at ? ` op ${formatDateTime(approvalRequest.answered_at)}` : ''}
                        {byName(approvalRequest.answered_by_name)}.
                    </p>
                    {approvalRequest.rejection_reason && <p>Reden: {approvalRequest.rejection_reason}</p>}
                    <p>De reden is gedeeld met je boekhouder.</p>
                </div>
            );
        case 'withdrawn':
            return (
                <div role="status" className="space-y-1 rounded-md border border-gray-200 bg-gray-50 px-4 py-3 text-sm text-gray-700">
                    <p className="font-medium text-gray-900">Verzoek ingetrokken</p>
                    <p>Dit verzoek is ingetrokken door je boekhouder en is niet meer geldig.</p>
                </div>
            );
    }
}
